import React from "react";
import "../styles/DisciplinePicker.css";
import { useTranslation } from "react-i18next";

const DisciplinePicker = ({
  disciplines,
  selectedDiscipline,
  onSelect,
  onResetDate,
  onResetSlot,
  isLoading,
}) => {
  const { t } = useTranslation();

  const handleChange = (e) => {
    const value = e.target.value;
    onSelect(value);
    onResetDate();
    onResetSlot();
  };

  return (
    <div className="discipline-picker-box_v3">
      <label htmlFor="discipline" className="discipline-label_v3">
        {t("pat_new_sched.select_discipline_label")}
      </label>

      {isLoading ? (
        <div className="loading-spinner_v3">
          {t("pat_new_sched.loading_disciplines")}
        </div>
      ) : (
        <select
          id="discipline"
          value={selectedDiscipline || ""}
          onChange={handleChange}
          className="discipline-dropdown_v3"
          disabled={isLoading}
        >
          <option value="">{t("pat_new_sched.choose_placeholder")}</option>
          {disciplines.map((disc) => (
            <option key={disc.id} value={disc.id}>
              {disc.label}
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default DisciplinePicker;
